import React from 'react';

const buildPageList = (current, last) => {
  if (last <= 7) return Array.from({ length: last }, (_, i) => i + 1);

  const inRange = (n) => n >= 1 && n <= last;

  if (current < 3) {
    const block = [1, 2, 3].filter(inRange);
    return [...block, '…', last];
  }

  if (current > last - 2) {
    const block = [last - 2, last - 1, last].filter(inRange);
    return [1, '…', ...block];
  }

  const mid = [current - 1, current, current + 1].filter(inRange);
  return [1, '…', ...mid, '…', last];
};

export default function Pagination({ current, totalPages, onChange, className = '' }) {
  const pageList = buildPageList(current, totalPages);

  const go = (p) => {
    if (typeof p !== 'number') return;
    const clamped = Math.min(Math.max(1, p), totalPages);
    if (clamped !== current) onChange(clamped);
    // Optionally scroll-to-top here if desired:
    // window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`flex justify-center items-center gap-2 ${className}`}>
      {pageList.map((p, idx) =>
        p === '…' ? (
          <span key={`ellipsis-${idx}`} className="px-2 py-1 text-gray-500 select-none">…</span>
        ) : (
          <button
            key={p}
            onClick={() => go(p)}
            className={`px-3 py-1 border rounded ${current === p ? 'bg-black text-white' : 'bg-white'}`}
          >
            {p}
          </button>
        )
      )}
    </div>
  );
}
